import React, {useContext, useEffect} from 'react';
import './Toast.scss';
import {constructClassNames} from "../../helpers/helpers";
import {ToastContext} from "../../contexts/toastContext";
import CloseIcon from "@mui/icons-material/Close";
const Toast = () => {
  const { showToast, toast, closeToast } = useContext(ToastContext);

  useEffect(() => {
    if (!!showToast && !toast?.close) {
      setTimeout(() => {
        closeToast();
      }, 4000);
    }
  }, [showToast]);

  const classes = [
    {name: 'ToastVisible', condition: showToast},
    {name: 'ToastSuccess', condition: toast?.type === 'success'},
    {name: 'ToastError', condition: toast?.type === 'error'},
    {name: 'ToastInfo', condition: toast?.type === 'info'}
  ];

  return (
    <div className={constructClassNames('Toast', classes)}>
      <div className='text'>
        {toast?.text}
      </div>
      {toast?.close && (
        <div className='closeButton' onClick={closeToast}>
          <CloseIcon fontSize='small' />
        </div>
      )}
    </div>
  )
};

export default Toast;
